var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-page"},[_c('p',{staticClass:"article-title"},[_vm._v(_vm._s(_vm.articleInfo.title || "-"))]),_c('p',{staticClass:"article-time"},[_vm._v(_vm._s(_vm.articleInfo.createdTime || "-"))]),_c('div',{staticClass:"article-html",domProps:{"innerHTML":_vm._s(_vm.articleInfo.content || '-')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }